import IBaseRespone from '../../model/respone/IBaseRespone';
import httpClient from '../httpService';
import { BSKT_GetTreeView_DotTuyenSinh_Nganh, dmChuyenNganh } from './ChuyenNganhModels';

const ChuyenNganhApiUrl = '/api/chuyennganh';
export const ChuyenNganhService = {
    getChuyenNganhSauDaiHoc: async (): Promise<dmChuyenNganh[]> => {
        const res = await httpClient.get(`${ChuyenNganhApiUrl}/SelectBySauDaiHoc`);
        return res?.data ?? [];
    },
    getTreeViewDotTuyenNganh: async (): Promise<BSKT_GetTreeView_DotTuyenSinh_Nganh[]> => {
        const res = await httpClient.get(`${ChuyenNganhApiUrl}/GetTreeViewDotTuyenNganh`);
        return res.data;
    }
};
